import { createResourcesFilter, ensureArray, FormState } from '@MyRequests/helpers';

export function isFormFullExcludingJustification(formState: FormState) {
  return (
    formState.selectedIntegration?.value !== undefined &&
    formState.selectedResourceType?.value !== undefined &&
    formState.selectedResource?.length !== 0 &&
    (formState.selectedPermission?.value !== undefined || formState.selectedMultiplePermission?.length !== 0)
  );
}

export function createAccessRequestClientModel(formState: FormState) {
  return {
    filter_integration_ids: ensureArray(formState.selectedIntegration?.value ?? []),
    filter_resource_type_ids: ensureArray(formState.selectedResourceType?.value ?? []),
    filter_resource_ids: [],
    filter_permission_ids: ensureArray(
      formState.selectedPermission?.value ?? formState.selectedMultiplePermission?.map((p) => p.value) ?? [],
    ),
    filter_bundle_ids: [],
    filter_access_unit_ids: [],
    filter_resources: createResourcesFilter(formState.selectedResource ?? []),
  };
}
